import { useCreateGroupMutation, useUpdateGroupMutation } from '@entities/clients/rtk-query.ts';
import { useGroup } from '@entities/common/groups/model';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { capitalizeString } from '@shared/helpers/index.ts';
import { useAppDispatch } from '@shared/hooks';
import type { Group } from '@shared/types/common';
import { base64ToFile } from '@src/library/helpers/events/base64ToFile';
import { showPopup } from '@src/library/redux/modal';

// export const useFormSubmit = (groupId: number, onSuccess?: () => void) => {
//   const dispatch = useAppDispatch();
//   const { setGroup, addGroup } = useGroup(groupId);
//   const navigate = useNavigate();
//   const [progress, setProgress] = React.useState<number>(0);
//   const [uploadStatus, setUploadStatus] = React.useState<'idle' | 'loading'>('idle');
//
//   const config = {
//     onUploadProgress: (progressEvent: any) => {
//       const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//       setProgress(percentCompleted);
//     },
//   };
//
//   const createFormData = (data: Group) => {
//     const group = new FormData();
//     group.append('name', data.name);
//
//     if (data.photo instanceof File) {
//       group.append('photo', data.photo);
//     } else if (typeof data.photo === 'string' && data.photo.includes('base64')) {
//       group.append('photo', base64ToFile(data.photo));
//     }
//
//     console.log(group);
//     return group;
//   };
//
//   const createGroup = async (data: Group) => {
//     setUploadStatus('loading');
//     const group = createFormData(data);
//     const response = await xhr.post<Group>(groupsApi, group, config);
//     setUploadStatus('idle');
//     return response;
//   };
//
//   const updateGroup = async (data: Group) => {
//     setUploadStatus('loading');
//     const group = createFormData(data);
//     const response = await xhr.patch<Group>(`${groupsApi}${groupId}/`, group, config);
//     setUploadStatus('idle');
//     return response;
//   };
//
//   const onSubmit = async (data: Group) => {
//     try {
//       let response: AxiosResponse<Group>;
//       if (isNaN(groupId)) {
//         response = await createGroup(data);
//         addGroup(response.data);
//         // navigate(`/clients/groups/${response.data.id}`);
//         // window.location.reload();
//       } else {
//         response = await updateGroup(data);
//         setGroup(response.data);
//         // navigate(`/clients/groups/${groupId}`);
//       }
//
//       if (!response.data) {
//         throw response;
//       }
//       if (onSuccess) {
//         dispatch(
//           showPopup({
//             type: 'success',
//             text: `Группа успешно ${isNaN(groupId) ? 'создана' : 'обновлена'}`,
//           })
//         );
//         navigate(-1);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };
//
//   const onGroupSubmit = (data: Group) => {
//     onSubmit(data);
//   };
//
//   return {
//     createGroup,
//     updateGroup,
//     uploadStatus,
//     onGroupSubmit,
//     progress,
//   };
// };

export const useFormSubmit = (groupId: number, onSuccess?: () => void) => {
  const dispatch = useAppDispatch();
  const { setGroup, addGroup } = useGroup(groupId);
  const navigate = useNavigate();

  const [uploadStatus, setUploadStatus] = React.useState<'idle' | 'loading'>('idle');

  const [createGroupMutation] = useCreateGroupMutation();
  const [updateGroupMutation] = useUpdateGroupMutation();

  const createFormData = (data: Group) => {
    const group = new FormData();
    group.append('name', capitalizeString(data.name));

    if (data.photo instanceof File) {
      group.append('photo', data.photo);
    } else if (typeof data.photo === 'string' && data.photo.includes('base64')) {
      group.append('photo', base64ToFile(data.photo));
    }

    return group;
  };

  const createGroup = async (data: Group) => {
    setUploadStatus('loading');
    const group = createFormData(data);
    const response = await createGroupMutation(group);
    setUploadStatus('idle');
    return response;
  };

  const updateGroup = async (data: Group) => {
    setUploadStatus('loading');
    const group = createFormData(data);
    const response = await updateGroupMutation({ id: groupId, body: group });
    setUploadStatus('idle');
    return response;
  };

  const onSubmit = async (data: Group) => {
    try {
      let response;
      if (isNaN(groupId)) {
        response = await createGroup(data);
        response?.data && addGroup(response?.data);
      } else {
        response = await updateGroup(data);
        response?.data && setGroup(response.data);
      }

      if (!response.data) {
        throw response;
      }

      if (onSuccess) {
        dispatch(
          showPopup({
            type: 'success',
            text: `Группа успешно ${isNaN(groupId) ? 'создана' : 'обновлена'}`,
          })
        );
        navigate(-1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onGroupSubmit = (data: Group) => {
    onSubmit(data);
  };

  return {
    createGroup,
    updateGroup,
    uploadStatus,
    onGroupSubmit,
  };
};
